import { render, staticRenderFns } from "./chain.vue?vue&type=template&id=3f8e070a&"
import script from "./chain.vue?vue&type=script&lang=js&"
export * from "./chain.vue?vue&type=script&lang=js&"
import style0 from "./chain.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports